import {METADATA_FETCH, METADATA_FETCH_FAILED, METADATA_FETCH_SUCCESS} from "../mutations/available";
import {getMetadataSection} from "../getters/metadata";
import {RequestState} from "../../requestState";


export async function clientUpdateInvoiceEmail({state, commit, dispatch}, {clientId, email, agreementText}) {
  return dispatch('metadataUpdate', {
    table: 'clients',
    id: clientId,
    delta: {
      invoiceEmail: email,
      agreementText: agreementText,
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/actions/client.js